 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTNAV from '@/components/Text/nav'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTPREFACE1938 from '@/components/Text/preface1938'
 import TEXTFOREWORD1997 from '@/components/Text/foreword1997'
 import TEXTTRANSINTRO from '@/components/Text/transintro'
 import TEXTTRANSACKN from '@/components/Text/transackn'
 import TEXTPREFACE1930 from '@/components/Text/preface1930'
 import TEXTCHAPTER1 from '@/components/Text/chapter1'
 import TEXTCHAPTER2 from '@/components/Text/chapter2'
 import TEXTCHAPTER3 from '@/components/Text/chapter3'
 import TEXTCHAPTER4 from '@/components/Text/chapter4'
 import TEXTCHAPTER5 from '@/components/Text/chapter5'
 import TEXTCHAPTER6 from '@/components/Text/chapter6'
 import TEXTCHAPTER7 from '@/components/Text/chapter7'
 import TEXTPHOTOS from '@/components/Text/photos'
 import TEXTCHAPTER8 from '@/components/Text/chapter8'
 import TEXTCHAPTER9 from '@/components/Text/chapter9'
 import TEXTCHAPTER10 from '@/components/Text/chapter10'
 import TEXTCHAPTER11 from '@/components/Text/chapter11'
 import LOVE_2 from '@/components/love_2'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTPOSTFACE from '@/components/Text/postface'
 import TEXTPOSTFACENOTES from '@/components/Text/postfacenotes'
 import TEXTPOSTSCRIPT from '@/components/Text/postscript'
 import TEXTPOSTSCRIPTNOTES from '@/components/Text/postscriptnotes'
 import TEXTINDEX from '@/components/Text/index'
 import TEXTMORE from '@/components/Text/more'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/nav",
 			"name" : "Text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/preface1938",
 			"name" : "Text/preface1938",
 			"component" : TEXTPREFACE1938
 		},
 		{
 			"path" : "/Text/foreword1997",
 			"name" : "Text/foreword1997",
 			"component" : TEXTFOREWORD1997
 		},
 		{
 			"path" : "/Text/transintro",
 			"name" : "Text/transintro",
 			"component" : TEXTTRANSINTRO
 		},
 		{
 			"path" : "/Text/transackn",
 			"name" : "Text/transackn",
 			"component" : TEXTTRANSACKN
 		},
 		{
 			"path" : "/Text/preface1930",
 			"name" : "Text/preface1930",
 			"component" : TEXTPREFACE1930
 		},
 		{
 			"path" : "/Text/chapter1",
 			"name" : "Text/chapter1",
 			"component" : TEXTCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js